<div [ngClass]="{ 'p-6 h-dvh': true }">
  <app-receipt
    [hideDownloadButton]="true"
    [receiptData]="receiptData()"
    [isLoading]="isLoading()"
    [isInvoice]="isInvoice"
  ></app-receipt>
</div>
